import jwt_decode from "jwt-decode";
import {
  ImpexAdmin,
  ImpexFinance,
  ImpexOperations,
  SuperAdmin,
  SupplierAdmin,
  SupplierFinance,
  SupplierOperations,
} from "../global-const/permissionName";
import { basicAuthHeaders } from "./dataService";
import http, { host } from "./httpService";

const impexRoles = [
  ImpexAdmin,
  ImpexFinance,
  ImpexOperations,
  SupplierFinance,
  SupplierOperations,
  SupplierAdmin,
  SuperAdmin,
];
class ImpexUser {
  userDetails = {};
  isImpexUser = false;
  isSupplierOperation = false;
  isSupplierFinance = false;
  isImpexOperation = false;
  isImpexFinance = false;
  isImpexAdmin = false;
  isSupplierAdmin = false;
  isSystemAdmin = false;

  userType = "";
  globalID = null;
  designation = "";
  companyName = "";
  constructor(token, role = "") {
    this.userDetails = jwt_decode(token);
    this.companyName = this.userDetails?.CompanyName;
    this.userType = this.userDetails["UserType"];
    if (this.userDetails["GlobalId"]) {
      this.globalID = this.userDetails["GlobalId"];
    }
    if (impexRoles.includes(role)) {
      this.isImpexUser = true;
      if (role === ImpexOperations) {
        this.isImpexOperation = true;
        this.designation = "Impex Operation";
      } else if (role === SupplierOperations) {
        this.isSupplierOperation = true;
        this.designation = "Supplier Operation";
      } else if (role === ImpexFinance) {
        this.isImpexFinance = true;
        this.designation = "Impex Finance";
      } else if (role === SupplierFinance) {
        this.isSupplierFinance = true;
        this.designation = "Supplier Finance";
      } else if (role === ImpexAdmin) {
        this.isImpexOperation = true;
        this.isImpexFinance = true;
        this.isImpexAdmin = true;
        this.designation = "Impex Admin";
      } else if (role === SupplierAdmin) {
        this.isSupplierFinance = true;
        this.isSupplierOperation = true;
        this.isSupplierAdmin = true;
        this.designation = "Supplier Admin";
      } else if (role === SuperAdmin) {
        this.isImpexUser = true;
        this.isSupplierOperation = true;
        this.isSupplierFinance = true;
        this.isImpexOperation = true;
        this.isImpexFinance = true;
        this.isImpexAdmin = true;
        this.isSupplierAdmin = true;
        this.isSystemAdmin = true;
      }
    } else this.isImpexUser = false;
  }

  getUserFullName() {
    return this.userDetails["FirstName"] + " " + this.userDetails["LasteName"];
  }
}

export const login = async (credentials) => {
  try {
    const response = await http.post(host + "AuthenticateAdm", credentials);
    const adminResponse = await http.get(host + "GetRolesDetailByUserId", {
      params: {
        UserId: jwt_decode(response.data.Token)["UserId"],
      },
      headers: {
        Authorization: `Bearer ${response.data.Token}`,
      },
    });
    await http.put(
      host +
        `UpdateLastLogin?UserId=${jwt_decode(response.data.Token)["UserId"]}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${response.data.Token}`,
        },
      }
    );
    if (impexRoles.includes(adminResponse.data[0]["RoleName"])) {
      return {
        role: adminResponse.data[0]["RoleName"],
        token: response.data.Token,
      };
    } else {
      throw new Error("You are not authorized to access impex.");
    }
  } catch (error) {
    throw new Error("Username or password is incorrect.");
  }
};

export const verifyOTP = async (userID, OTP) => {
  return await http.post(
    host + "VerifyOTP",
    {
      UserId: userID,
      OTP: OTP,
    },
    {
      headers: basicAuthHeaders,
    }
  );
};

export const logout = () => {
  localStorage.removeItem("_imp_at");
  localStorage.removeItem("_impr");
  localStorage.removeItem("purchaseOrder");
  localStorage.removeItem("ACCEPTED PO");
  localStorage.removeItem("qualityCheck");
};

export const getUser = () => {
  try {
    const requestedUser = new ImpexUser(
      localStorage.getItem("_imp_at"),
      localStorage.getItem("_impr")
    );
    return requestedUser;
  } catch (error) {
    logout();
  }
};

export const getToken = () => {
  return localStorage.getItem("_imp_at");
};

export const getRole = () => {
  return localStorage.getItem("_impr");
};

http.setTokenInHeader(getToken());
